import RichText from '@eneco/components/RichText/RichText';
import { Box, Stack, StepList, Text } from '@eneco/sparky';
import { ClockIcon, SuccessIcon } from '@eneco/sparky/icons';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import InfoComponent from '../../../../components/InfoComponent';

export const CompletedProgressTimelineCard = () => {
  const { fields } = useContent<DashboardOverviewRendering>();
  const {
    stepOneTitle,
    stepOneDescription,
    stepTwoTitle,
    stepTwoDescription,
    stepThreeTitle,
    stepThreeDescription,
    stepFourTitle,
    stepFourDescription,
  } = fields.completedProgressTimelineCard;
  const clockIcon = <ClockIcon color={'iconSecondary'} />;
  const checkmarkIcon = (
    <Box backgroundColor={'backgroundPrimary'}>
      <SuccessIcon color={'feedbackSuccess'} />
    </Box>
  );

  const steps = [
    {
      step: '1',
      title: stepOneTitle?.value,
      tooltip: stepOneDescription?.value,
      icon: checkmarkIcon,
    },
    {
      step: '2',
      title: stepTwoTitle?.value,
      tooltip: stepTwoDescription?.value,
      icon: checkmarkIcon,
    },
    {
      step: '3',
      title: stepThreeTitle?.value,
      tooltip: stepThreeDescription?.value,
      icon: checkmarkIcon,
    },
    {
      step: '4',
      title: stepFourTitle?.value,
      tooltip: stepFourDescription?.value,
      icon: clockIcon,
    },
  ];
  return (
    <StyledDashboardBlock>
      <StepList>
        {steps.map(({ step, title, tooltip, icon }) => (
          <StepList.Item key={step} step={step} icon={icon}>
            <Stack direction={'row'} gap={1}>
              <Text weight={'bold'}>{title}</Text>
              {tooltip && (
                <InfoComponent variant="icon" triggerText={title}>
                  <RichText html={tooltip} />
                </InfoComponent>
              )}
            </Stack>
          </StepList.Item>
        ))}
      </StepList>
    </StyledDashboardBlock>
  );
};
